
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'OrderTypeCard' })
export default class extends Vue {
  @Prop({ required: true }) title!: string
  @Prop({ required: true }) description!: string
  @Prop({ default: 'el-icon-bank-card' }) icon!: string
  @Prop({ default: false }) selected!: boolean
  @Prop({ default: false }) disabled!: boolean

  handleClick(): void {
    if (this.disabled) return
    this.$emit('select')
  }
}
